(() => {
  if (customElements.get('avontic-stand-card')) return;
  customElements.define('avontic-stand-card', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.addEventListener('change', event => {
        if (event.target.matches('[data-stand-version]')) this.sync();
      }, { signal: this.abort.signal });
      this.sync();
    }
    disconnectedCallback() { this.abort?.abort(); }
    sync() {
      const select = this.querySelector('[data-stand-version]');
      const option = select?.selectedOptions[0];
      if (!option) return;
      // Currency apps may inject a money span even into escaped data attributes.
      this.querySelector('[data-stand-price]').textContent = (option.dataset.price || '').replace(/<[^>]*>/g, '');
      const image = this.querySelector('.av-stand-card__image');
      if (image && option.dataset.image) {
        if (image.getAttribute('src') !== option.dataset.image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
        }
        image.alt = option.dataset.alt || `${this.dataset.standName} — ${option.textContent.trim()}`;
      }
      const available = option.dataset.available === 'true';
      this.querySelector('[data-stand-add]').disabled = !available;
      this.querySelector('[data-stand-button-label]').textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      this.querySelectorAll('[data-stand-link]').forEach(link => {
        const url = new URL(link.href, location.origin);
        url.searchParams.set('variant', select.value);
        const current = new URL(location.href);
        ['preview_theme_id', 'currency', 'country'].forEach(key => {
          if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
        });
        link.href = url.href;
      });
    }
  });
})();
